import React, { useEffect, useState } from "react";
import { useAuth } from "./auth";
import { addPayment, addTenant, getTenantByPg } from "./apiService";
import { useNavigate } from "react-router-dom";

const AddTenant = () => {
  const [guestname, setGuestname] = useState("");
  const [mobileno, setMobileno] = useState("");
  const [aadharno, setAadharno] = useState("");
  const [joindate, setJoindate] = useState("");
  const [rentamt, setRentamt] = useState("");
  const [advamt, setAdvamt] = useState("");
  const [paymentdate, setPaymentdate] = useState("");
  const [paidstatus, setPaidstatus] = useState(false);
  const [errors, setErrors] = useState({});
  const [guests, setGuests] = useState([]);

  const { roomid, bcount, pgid } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getTenantByPg(pgid)
      .then((res) => {
        setGuests(res);
      })
      .catch((e) => console.log(e));
  }, [pgid]);

  const handleTenantSubmit = () => {
    let errors = {};
    let totalamt = 0;
    const re1 = new RegExp("^[6-9][0-9]{9}$");
    const re2 = new RegExp("^[0-9]{12}$");

    if (!guestname) errors.guestname = "Guest name is required";
    if (!re1.test(mobileno)) errors.mobileno = "Enter valid mobile number";
    if (!re2.test(aadharno)) errors.aadharno = "Enter valid aadhar number";
    if (!joindate) errors.joindate = "select valid joining date";
    if (!rentamt) errors.rentamt = "Enter Tenant rent amount";
    if (!advamt) errors.advamt = "Enter Tenant Advance amount";
    if (!paymentdate) errors.paymentdate = "Enter Tenant next payment date";

    guests.forEach((guest) => {
      if (guest.name === guestname) {
        errors.guestname = "guest already exists with same name in PG";
        // console.log(errors.username);
      }
      if (guest.mobileno === mobileno) {
        errors.mobileno = "Another guest with same Mobile No..??";
        // console.log(errors.mobileno);
      }
      if (guest.aadharNo === aadharno) {
        errors.aadharno = "Guest is there with same Aadhar NO";
      }

      return errors;
    });

    setErrors(errors);

    const fguests = guests.filter((guest) => {
      return guest.roomNo === roomid;
    });
    // console.log(Object.keys(fguests).length);

    totalamt = parseInt(rentamt) + parseInt(advamt);

    try {
      if (Object.keys(errors).length === 0) {
        if (Object.keys(fguests).length < bcount) {
          const tenant = {
            name: guestname,
            mobileno: mobileno,
            aadharNo: aadharno,
            joinedDate: joindate,
            rentAmt: rentamt,
            balAmt: rentamt,
            advAmt: advamt,
            paymentDate: paymentdate,
            paid: paidstatus,
            pgname: pgid,
            roomNo: roomid,
          };

          addTenant(tenant);

          if (paidstatus) {
            const payment = {
              pname: guestname,
              paadhar: aadharno,
              pamount: totalamt,
              paymentDate: joindate,
              pgname: pgid,
            };

            addPayment(payment);
          }
          setGuestname("");
          setMobileno("");
          setAadharno("");
          setJoindate("");
          setRentamt("");
          setAdvamt("");
          setPaymentdate("");
          setPaidstatus(false);
          navigate("/Dashboard/MyPGDetails/RoomDetails");
        } else {
          alert(
            "The total beds in the current Room was occupied. Try any other rooms/PG or increase the Room beds"
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="container-box">
      <div className="container">
        <div className="header">New Guest</div>
        <div className="label">
          Guest Name:
          <input
            type="text"
            className="inputbox"
            name="guestname"
            value={guestname}
            onChange={(e) => setGuestname(e.target.value)}
          />
          {errors.guestname ? (
            <div className="errortext">{errors.guestname}</div>
          ) : null}
        </div>

        <div className="label">
          Mobile No:
          <input
            type="text"
            className="inputbox"
            name="mobileno"
            value={mobileno}
            onChange={(e) => setMobileno(e.target.value)}
          />
          {errors.mobileno ? (
            <div className="errortext">{errors.mobileno}</div>
          ) : null}
        </div>

        <div className="label">
          Aadhar No:
          <input
            type="text"
            className="inputbox"
            name="aadharno"
            value={aadharno}
            onChange={(e) => setAadharno(e.target.value)}
          />
          {errors.aadharno ? (
            <div className="errortext">{errors.aadharno}</div>
          ) : null}
        </div>

        <div className="label">
          Joining Date:
          <input
            type="date"
            className="inputbox"
            name="joindate"
            value={joindate}
            onChange={(e) => setJoindate(e.target.value)}
          />
          {errors.joindate ? (
            <div className="errortext">{errors.joindate}</div>
          ) : null}
        </div>

        <div className="label">
          Rent Amount:
          <input
            type="text"
            className="inputbox"
            name="rentamt"
            value={rentamt}
            onChange={(e) => setRentamt(e.target.value)}
          />
          {errors.rentamt ? (
            <div className="errortext">{errors.rentamt}</div>
          ) : null}
        </div>

        <div className="label">
          Advance Amount:
          <input
            type="text"
            className="inputbox"
            name="advamt"
            value={advamt}
            onChange={(e) => setAdvamt(e.target.value)}
          />
          {errors.advamt ? (
            <div className="errortext">{errors.advamt}</div>
          ) : null}
        </div>

        <div className="label">
          Payment Status:
          <input
            type="checkbox"
            className="checkbox"
            name="paidstatus"
            value={paidstatus}
            onChange={(e) => setPaidstatus(e.target.checked)}
          />
          {errors.advamt ? (
            <div className="errortext">{errors.advamt}</div>
          ) : null}
        </div>

        <div className="label">
          Next Payment Date:
          <input
            type="date"
            className="inputbox"
            name="paymentdate"
            value={paymentdate}
            onChange={(e) => setPaymentdate(e.target.value)}
          />
          {errors.paymentdate ? (
            <div className="errortext">{errors.paymentdate}</div>
          ) : null}
        </div>

        <input
          type="submit"
          className="btn-cls"
          value="Submit"
          onClick={handleTenantSubmit}
        />
      </div>
    </div>
  );
};

export default AddTenant;
